// Review-specific so SQL charts can be reviewed without widening the
// global content type
export var ContentReviewContentType;
(function (ContentReviewContentType) {
    ContentReviewContentType["CHART"] = "chart";
    ContentReviewContentType["DASHBOARD"] = "dashboard";
    ContentReviewContentType["SQL_CHART"] = "sql_chart";
    ContentReviewContentType["DOCUMENT"] = "document";
})(ContentReviewContentType || (ContentReviewContentType = {}));
export var ContentReviewRequestStatus;
(function (ContentReviewRequestStatus) {
    ContentReviewRequestStatus["PENDING"] = "pending";
    ContentReviewRequestStatus["APPROVED"] = "approved";
    ContentReviewRequestStatus["REJECTED"] = "rejected";
    ContentReviewRequestStatus["CANCELLED"] = "cancelled";
})(ContentReviewRequestStatus || (ContentReviewRequestStatus = {}));
export var ContentReviewRequestView;
(function (ContentReviewRequestView) {
    ContentReviewRequestView["TO_REVIEW"] = "to-review";
    ContentReviewRequestView["MINE"] = "mine";
})(ContentReviewRequestView || (ContentReviewRequestView = {}));
export var ContentReviewNotificationEvent;
(function (ContentReviewNotificationEvent) {
    ContentReviewNotificationEvent["SUBMITTED"] = "submitted";
    ContentReviewNotificationEvent["APPROVED"] = "approved";
    ContentReviewNotificationEvent["REJECTED"] = "rejected";
})(ContentReviewNotificationEvent || (ContentReviewNotificationEvent = {}));
export const getContentReviewRequestsPath = (projectUuid) => `/projects/${projectUuid}/review-requests`;
export const getContentReviewRequestPath = (projectUuid, requestUuid) => `${getContentReviewRequestsPath(projectUuid)}/${requestUuid}`;
//# sourceMappingURL=contentReviewRequests.js.map